import React, { useState, useEffect, useLayoutEffect } from "react";
import "./SBoardMessage.scss";

import { getMessageService } from "./SBoardMessage-service";
import {
  IonGrid,
} from "@ionic/react";

import {
  messageResultInterface,
} from "../SBoardMessage/SBoardMessage.modal";
import Loader from "../../../../../../../../components/Shared/Loader/Loader";
import SBoardMessageCard from "./SBoardMessageCard/SBoardMessageCard";
import { MessageDataModel } from "./models/MessageData.model";
import { utilService } from "../../../../../../../../services";
import NoResults from "../../../../../../../../components/Shared/NoResults/NoResultsComponent";
import { statusBoardService } from "../../../../../../StatusBoard.service";
import { rolePermissionsService } from "../../../../../../../../services/rolePermissions.service";
import InfiniteScroll from "react-infinite-scroll-component";
import _ from "lodash";
import { dataTransferService } from "../../../../../../../../services/dataTransferService";

interface ContainerProps {
  showModal: boolean;
  onCancel: () => void;
}

const SBoardMessage: React.FC<ContainerProps> = (props) => {
  const [messageListData, setmessageListData]: any = useState([]);
  const [isLoaderActive, setLoaderStatus] = useState(true);
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [pageNo, setPageNo]: [number, Function] = useState(1);
  const [notesNextValue, setNotesNextValue]: any = useState("");

  async function searchNext($event: CustomEvent<void>) {
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }
  useEffect(() => {
    fetchMessageList();
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
  }, []);


  useLayoutEffect(() => {
    let sub = dataTransferService.getSmsListAction.subscribe(
      (data: any) => {
        if (!_.isEmpty(data)) {
          fetchMessageList();
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);

  const fetchMessageList = async (page:number = 1) => {
    let apiParams = getMessageDetailsParams(page);
    setLoaderStatus(true);
    const respMessageList: messageResultInterface =
      await getMessageService.getMessage(apiParams);
    if (respMessageList.isSuccess && respMessageList.result) {
      setNotesNextValue(respMessageList.result.next);
      if (pageNo === 1) {
        setmessageListData(_.cloneDeep(respMessageList?.result.data));
      } else {
        setmessageListData([
          ...messageListData,
          ...respMessageList?.result.data,
        ]);
      }
      setPageNo(pageNo + 1);
    } else {
      getMessageService.handleErrorResponse();
    }
    setLoaderStatus(false);
  };
  const setupdatedmessageListData = (dataFromMessageCard: any) => {
    setmessageListData(dataFromMessageCard);
  };
  const getMessageDetailsParams = (page:any) => {
    const apiParams = {
      pid:
        statusBoardService.rowData && statusBoardService.rowData.pid
          ? statusBoardService.rowData.pid
          : "",
      page: page,
      reg_code: utilService.getNetwork(),
    };
    return apiParams;
  };

  const onScroll = () => {
    if (!_.isEmpty(notesNextValue)) {
      setPageNo(pageNo + 1)
      fetchMessageList(pageNo + 1);
    }
  };

  return (
    <div className="sboard-message-container">
      <div className="sboard-sms-wrapper">
        <div className="sms-header-wrapper">
          <div className="sms-heading">
            <b> MESSAGES</b>
          </div>
        </div>
        <IonGrid>
          <div className="prev-sms-container">
            {isLoaderActive && (
              <div className="sb-loader-container">
                <Loader></Loader>
              </div>
            )}
            <InfiniteScroll
              dataLength={messageListData.length}
              height={460}
              next={() => onScroll()}
              hasMore={true}
              loader={<div></div>}
            >
              {messageListData && messageListData.length ? (
                <div className="sb-parent-card">
                  {messageListData &&
                    messageListData.map(
                      (item: MessageDataModel, index: number) => {
                        return (
                          <SBoardMessageCard
                            messageData={item}
                            key={index}
                            updateMessageList={setupdatedmessageListData}
                            permissions={rolePermissions}
                          ></SBoardMessageCard>
                        );
                      }
                    )}
                </div>
              ) : (
                !isLoaderActive && (
                  <div>
                    <NoResults></NoResults>
                  </div>
                )
              )}
            </InfiniteScroll>
          </div>
        </IonGrid>
      </div>
    </div>
  );
};

export default SBoardMessage;
